/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qr_Warehouse_ErrorInputs */

const vi_qr_warehouse_error = /** @type {(inputs: Qr_Warehouse_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tìm thấy phiếu xuất kho cho mã này.`)
};

/**

* @param {Qr_Warehouse_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const qr_warehouse_error = /** @type {((inputs?: Qr_Warehouse_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qr_Warehouse_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_qr_warehouse_error(inputs)
});